import React, { Component } from 'react';

export default class NotFound extends Component {
    render() {
        return (
            <div className="kt-grid kt-grid--ver kt-grid--root kt-page">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v3" style={{backgroundImage: `url(assets/media/error/bg3.jpg)`}}>
                    <div className="kt-error_container">
                        <span className="kt-error_number">
                            <h1>404</h1>
                        </span>
                        <p className="kt-error_title" >
                            How did you get here
                        </p>
                        <p className="kt-error_subtitle">
                            Sorry we can't seem to find the page you're looking for.
                        </p>
                        <p className="kt-error_description">
                            There may be amisspelling in the URL entered,<br/>
                            or the page you are looking for may no longer exist.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}
